import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { bodyFontFamily } from "styles/theme/mui";
import { homeHeaderTypography } from "../../styles";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            width: "100%",
            maxHeight: "100%",
            background: theme.palette.background.paper,
            borderRadius: 6,
            padding: 16,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            overflow: "hidden",
        },

        title: {
            ...homeHeaderTypography,
            fontSize: "16px !important",
            fontWeight: "600 !important",
            lineHeight: "23.12px !important",
            color: theme.palette.secondary.main,
            marginBottom: "14px !important",
            flexShrink: 0,
        },

        tableHeader: {
            height: 42,
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            alignItems: "center",
            background: theme.palette.grey[400],
            padding: "0 12px",
            boxSizing: "border-box",
            flexShrink: 0,

            "& p": {
                fontSize: "14px !important",
                fontWeight: "600 !important",
                color: theme.palette.text.primary,
                fontFamily: bodyFontFamily,
            },
        },

        tableBody: {
            width: "100%",
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            scrollbarWidth: "thin",
            scrollbarColor: `${theme.palette.divider} transparent`,

            "&::-webkit-scrollbar": {
                width: 6,
            },

            "&::-webkit-scrollbar-track": {
                background: "transparent",
            },

            "&::-webkit-scrollbar-thumb": {
                backgroundColor: theme.palette.divider,
                borderRadius: 10,
            },
        },

        tableRow: {
            height: 45,
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            alignItems: "center",
            padding: "0 12px",
            boxSizing: "border-box",
            borderBottom: `1px solid ${theme.palette.divider}`,
        },

        link: {
            fontSize: "14px !important",
            fontWeight: "600 !important",
            color: theme.palette.primary.main,
            textDecoration: "underline",
            cursor: "pointer",
            fontFamily: bodyFontFamily,
        },

        statusBadge: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: 58,
            height: 24,
            borderRadius: 4,
            color: theme.palette.common.white,
            fontSize: "14px !important",
            fontWeight: "600 !important",
            fontFamily: bodyFontFamily,
            padding: "6px",
        },

        text: {
            fontSize: "14px !important",
            fontWeight: "400 !important",
            color: theme.palette.secondary.main,
            fontFamily: bodyFontFamily,
        },

        dangerText: {
            fontSize: "14px !important",
            fontWeight: "600 !important",
            color: theme.palette.error.main,
            fontFamily: bodyFontFamily,
        },
    })
);
